import React from 'react'

const LostPage = () => {
  return (
    <div>You don lost lass lass na everybody go chop breakfast</div>
  )
}

export default LostPage